module.exports = require("././angular-translate-storage-local.js");


//////////////////
// WEBPACK FOOTER
// angular-translate-storage-local (bower component)
// module id = 385
// module chunks = 0